import React from 'react'

interface ParagraphContentPropType {
  heading: string
  content: string
}

const ParagraphContent = ({ heading, content }: ParagraphContentPropType) => {
  return (
    <div className='h-max w-full '>
      <h2 className='text-[16px] font-bold '>{heading}</h2>
      <p className='mt-6 whitespace-pre-wrap  text-left text-[16px] font-normal leading-6 text-[#2d3748]  '>
        {content}
      </p>
    </div>
  )
}

export default ParagraphContent
